var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 8191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.4426 7.22132C13.4426 12.0601 7.22132 16.2077 7.22132 16.2077C7.22132 16.2077 1 12.0601 1 7.22132C1 5.57132 1.65546 3.9889 2.82218 2.82218C3.9889 1.65546 5.57132 1 7.22132 1C8.87131 1 10.4537 1.65546 11.6204 2.82218C12.7872 3.9889 13.4426 5.57132 13.4426 7.22132Z",
    stroke: "#FFB718",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.22114 9.29481C8.3664 9.29481 9.29481 8.3664 9.29481 7.22114C9.29481 6.07588 8.3664 5.14746 7.22114 5.14746C6.07588 5.14746 5.14746 6.07588 5.14746 7.22114C5.14746 8.3664 6.07588 9.29481 7.22114 9.29481Z",
    stroke: "#FFB718",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation2);
export default __webpack_public_path__ + "static/media/location2.dd7881202c129693bbbc04a9a02e856a.svg";
export { ForwardRef as ReactComponent };